export type AccessMode = 'all' | 'selected' | 'none';

export function modeFromScope(scope: string[], legacyEmptyMeansAll = false): AccessMode {
  if (scope.includes('*') || (legacyEmptyMeansAll && scope.length === 0)) return 'all';
  return scope.length ? 'selected' : 'none';
}

export function effectiveAccessIds(scope: string[], eligibleIds: string[], legacyEmptyMeansAll = false): string[] {
  const mode = modeFromScope(scope, legacyEmptyMeansAll);
  if (mode === 'all') return eligibleIds;
  if (mode === 'none') return [];
  const eligible = new Set(eligibleIds);
  return Array.from(new Set(scope)).filter((id) => eligible.has(id));
}
